import { useMemo, useState } from 'react';

import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { ConfiguracaoPedidoAutoComplete, SituacaoPedidoLoteAutoComplete } from 'components/autocompletes';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function QuebrasGridFilter() {
    const data = useMemo(() => new Date(), []);

    const [filterConfigPedido, setFilterConfigPedido] = useState<FilterValuesProps>({
        property: 'idConfigPedido',
        operator: 'in',
        value: [],
        idProperty: 'idConfigPedido',
    });

    const [filterSituacao, setFilterSituacao] = useState<FilterValuesProps>({
        property: 'idStatusProcessamento',
        operator: 'in',
        value: [],
        idProperty: 'idStatusProcessamento',
    });

    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dhInclusao',
        operator: 'bt',
        startDate: null,
        endDate: null,
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterConfigPedido, setter: setFilterConfigPedido },
                { value: filterSituacao, setter: setFilterSituacao },
                { value: filterInterval, setter: setFilterInterval },
            ]}
        >
            <Grid sx={{ flex: 4 }}>
                <ConfiguracaoPedidoAutoComplete
                    value={filterConfigPedido.value}
                    multiple={true}
                    onChange={(e, value) => setFilterConfigPedido((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                    requestOptions={{
                        url: 'gestao/configpedido/loja',
                        sort: [{ property: 'idConfigPedido', direction: 'DESC' }],
                        filter: [
                            { property: 'fgAtivo', value: true, operator: 'eq' },
                            { property: 'dtInicioVigencia', operator: 'lte', value: data },
                            { property: 'dtFimVigencia', operator: 'gte', value: data },
                            { property: 'idTipoPedido', operator: 'eq', value: 2 },
                        ],
                        limit: 100,
                    }}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <SituacaoPedidoLoteAutoComplete
                    value={filterSituacao.value}
                    onChange={(e, value) => setFilterSituacao((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ width: '100%' }} size={{ lg: 4 }}>
                <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns} localeText={{ start: 'Data Início', end: 'Data Fim' }}>
                    <DateRangePicker
                        value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                        onChange={([startDate, endDate]) => {
                            setFilterInterval((oldState: FilterValuesProps) => ({
                                ...oldState,
                                startDate,
                                endDate,
                            }));
                        }}
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{
                            field: { dateSeparator: 'até' },
                            textField: { autoComplete: 'off' },
                        }}
                    />
                </LocalizationProvider>
            </Grid>
        </Filter>
    );
}
